import React from 'react';

import { CgFileDocument } from 'react-icons/cg';

import { HeaderMenuDrawerSingle } from '../HeaderMenuDrawerComponents';

const HeaderMenuDrawerDocs: React.FC = () => {
  return (
    <HeaderMenuDrawerSingle Icon={CgFileDocument} href={'https://docs.pactswap.io'}>
      Documentation
    </HeaderMenuDrawerSingle>
  );
};

export default HeaderMenuDrawerDocs;
